import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Icon } from '@types-custom/models/ui/icon-model';
import { ICardLuminaryModel } from '@types-custom/models/ui/card-luminary-model';
import { DrawerPanelService } from '@ui-core/services/drawer-panel/drawer-panel.service';

@Component({
  selector: 'citizen-panel-luminary',
  templateUrl: './panel-luminary.component.html',
  styleUrls: ['./panel-luminary.component.scss']
})
export class PanelLuminaryComponent implements OnInit, OnChanges {
  @Input() cards: ICardLuminaryModel[] = [];
  Icon = Icon;
  totalConectadas = 0;
  totalDesconectadas = 0;
  totalDesconocidas = 0;
  searchTerm = '';

  constructor(private drawerPanelService: DrawerPanelService) { }

  ngOnInit(): void {
    this.setIndicators(this.cards);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.cards) {
      this.setIndicators(this.cards);
    }
  }

  openModal(card: ICardLuminaryModel): void {
    this.drawerPanelService.collapseDrawer(true);
    card?.cardMapLink?.markerDispatcher.next(
      card.cardMapLink.markerModel
    );
  }

  closePanel(): void {
    this.drawerPanelService.collapseDrawer(true);
  }

  get filteredCards(): ICardLuminaryModel[] {
    const term = this.searchTerm.trim().toLowerCase();
    if (!term) {
      return this.cards;
    }

    return this.cards.filter((card) => {
      const values = [
        card.assetId,
        card.operator,
        card.lampType,
        card.dimmingStatus,
        card.status,
        card.controlProgramName,
        card.monitoringProgramName,
        card.alarmProgramName,
        card.elementIdentification?.toString(),
        card.associatedTelecellId?.toString(),
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

      return values.includes(term);
    });
  }

  formatElementId(value?: number): string {
    if (value === null || value === undefined) {
      return '---';
    }

    return value.toString().padStart(3, '0');
  }

  setIndicators(cards: ICardLuminaryModel[]) {
    let conectadas = 0;
    let desconectadas = 0;
    let desconocidas = 0;

    cards.map((card: ICardLuminaryModel) => {
      const status = card.status?.toLowerCase();
      if (!status || status === 'unknown') {
        desconocidas++;
        return;
      }

      const offlineStatuses = ['desconectado', 'apagada', 'apagado', 'off', 'inactivo'];
      if (offlineStatuses.includes(status)) {
        desconectadas++;
      } else {
        conectadas++;
      }
    });

    this.totalConectadas = conectadas;
    this.totalDesconectadas = desconectadas;
    this.totalDesconocidas = desconocidas;
  }

}

